<template>
  <div>
    <back-btn />
    <v-container>
      <v-row justify="center">
        <v-col cols="8">
          <del-person-form @emitData="createDelagatedPerson" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DelPersonForm from "@/components/delagated-person/DelPersonForm";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    DelPersonForm,
    BackBtn,
  },
  data: () => ({}),
  methods: {
    createDelagatedPerson(payload) {
      this.$store.dispatch("DelPerson/create", payload).then(() => {
        this.$router.push(`/delagated-person/${this.$route.params.patient_id}`);
      });
    },
  },
};
</script>
